export const platforms = {
  IOS: 'iOS',
  ANDROID: 'android',
  WINDOWS: 'windows',
};

export * from './countries';
